import definition from 'market_definition';
import definition_invoice from 'invoice_definition';
import definition_marketing from 'marketing_definition';//only work in test mode
import definition_payment from 'payment_definition';
import definition_file from 'file_definition';
import definition_asset from 'asset_definition';
import definition_communication from 'communication_definition';

import definition_task from 'task_definition';

global.app.sdk.market = global.app.create_sdk(definition, true);
global.app.sdk.invoice = global.app.create_sdk(definition_invoice, true);
global.app.sdk.payment = global.app.create_sdk(definition_payment, true);
global.app.sdk.file = global.app.create_sdk(definition_file, true);
global.app.sdk.asset = global.app.create_sdk(definition_asset, true);
global.app.sdk.communication = global.app.create_sdk(definition_communication, true);

//only work in test mode
if(global.app.name === 'market_ui'){
    global.app.sdk.marketing = global.app.create_sdk(definition_marketing);
    global.app.sdk.task = global.app.create_sdk(definition_task);
    global.app.sdk.tasks = global.app.create_sdk(definition_task);
}
